<template>
  <div class="d-flex justify-content-start align-items-center">
    <div class="pl-2">
      <img id="badge-verified"
           src="/static/img/badge-security.svg"
           alt=""
           width="24">
      <b-popover target="badge-verified"
                 placement="bottom"
                 triggers="hover"
                 :title="$t('message.professional.verified_background_check_title')"
                 :content="$t('message.professional.verified_background_check_detail')"/>
    </div>
    <div class="pl-2" v-if="professional.has_vacuum_cleaner">
      <img id="badge-vacuum-cleaner"
           src="/static/img/badge-vacuum-cleaner.svg"
           alt=""
           width="24">
      <b-popover target="badge-vacuum-cleaner"
                 placement="bottom"
                 triggers="hover"
                 :title="$t('message.professional.has_vacuum_cleaner')"
                 :content="$t('message.professional.has_vacuum_cleaner_detail')"/>
    </div>
    <div class="pl-2" v-if="professional.professional_pet_types.length > 0">
      <img id="badge-inconvenient-pet"
           src="/static/img/badge-inconvenient-pet.svg"
           alt=""
           width="24">
      <b-popover target="badge-inconvenient-pet"
                 placement="bottom"
                 triggers="hover"
                 :title="$t('message.professional.inconvenient_pet')"
                 :content="getPetTypes()"/>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['professional'],
    methods: {
      getPetTypes () {
        const petTypes = []
        for (const professionalPetType of this.professional.professional_pet_types) {
          let petTypeName = (this.$i18n.locale === 'th') ? professionalPetType.pet_type.name_th : professionalPetType.pet_type.name_en
          if (professionalPetType.pet_type.is_other === 1) {
            petTypeName = professionalPetType.other_remark
          }
          petTypes.push(petTypeName)
        }
        return petTypes.join(', ')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/components/CleanerBadges.vue